<template>
	<div class="points-mall-rules-page">
		<!-- 标题与说明 -->
		<div class="title-section">
			<h1 class="main-title">积分商城用户使用规则</h1>
			<p class="sub-desc">请仔细阅读以下内容</p>
		</div>

		<!-- 规则正文 -->
		<div class="rules-content">
			<p class="chapter-paragraph">
				一、总则本规则适用于所有完成了APP注册的用户。用户必须遵守本规则，否则其行为会被取消，积分会被冻结且可能承担法律责任。
			</p>

			<p class="chapter-paragraph">
				二、用户资格完成了APP注册的用户均可成为积分商城的用户。用户必须提供真实、准确和最新的个人信息，以便我们提供服务。用户有义务保管好自己的账户和密码，避免被他人盗用或滥用。
			</p>

			<span class="chapter-paragraph">
				三、积分获取积分可以通过以下方式获取：
			</span>
			<ul>
				<li>a. 购买特定机器商品并进行绑定；</li>
				<li>b. 参与活动；</li>
				<li>c. 完成任务；</li>
				<li>d. 其他符合规定的获取方式。</li>
			</ul>

			<span class="chapter-paragraph">四、积分使用</span>
			<ul>
				<li>a. 积分可以在积分商城中兑换商品或服务，或者参与抽奖活动。</li>
				<li>
					b.
					积分不能兑换成现金，也不能用于购买其他非商城商品或服务。积分有效期为两年，过期积分会被自动清除，用户应定期查看积分状态，以免造成损失。（例如：2023年01月02号所获得的积分会在2025年01月01号自动消除）
				</li>
				<li>
					c. 积分商城积分的扣减顺序，默认优先按照临近到期的积分进行扣减；若出现积分效期相同，则系统随机扣减。
				</li>
			</ul>

			<span class="chapter-paragraph">五、积分使用注册事项</span>
			<div>
				(1) 兑换实物礼品提供配送服务，仅限中国国内（不含港澳台地区和新疆、西藏地区）。自订单成功提交后，20个自然日内发货并由物流公司将礼品直接送至兑换时确认的收货地址。如遇元旦/春节/五一/十一等国家法定节假日、灾害天气、疫情、国家物流管制及偏远地区等相关原因，芬尼将有权延迟邮寄礼品。
			</div>
			<div>
				(2) 客户在收到实物礼品时请务必当场检查礼品包装是否完整，如果外包装破损、礼品缺失、或发现任何质量问题，当场应予以拒收，并在包裹单上注明原因；客户一旦签收即代表已收到礼品且礼品表面完好。
			</div>
			<div>
				(3) 除礼品在运送途中发生损毁或本身存在质量瑕疵以外，恕不接受退换礼品。
			</div>
			<div>
				(4) 所有礼品或服务，一经兑换成功，除有特别说明外，则不可取消或退还积分，请务必在兑换前仔细确认订单内容。
			</div>
			<div>
				(5) 用户进行积分兑换时，芬尼将发送动态验证码至用户注册的手机号码，凡正确输入动态验证码兑换积分礼品/服务均视为由客户本人完成的积分兑换；
			</div>
			<div>
				(6) 积分商城平台以及其他各类宣传品中展示的礼品/服务、奖品图片仅供参考，其颜色、外观、款式、服务内容等以实物/实际服务为准。
			</div>
			<div>
				(7) 客户提出兑换申请即视为同意芬尼将用户姓名、联系电话、礼品寄送地址等配送信息或接受服务信息提交礼品/服务供应商及配送物流公司，并接受礼品配送服务或服务提供方式。同时，为保证客户兑换体验与礼品质量，芬尼将有可能通过外呼、短信等形式开展客户回访调研。
			</div>
			<div>
				(8) 积分商城平台提供的所有可兑换礼品/服务的兑换条件、兑换数量限制请以兑换时礼品/服务介绍及操作页面提示为准，若用户下单后，若审核人员或供应商发现该商品已无库存，则订单会退回，积分和优惠券也会同时退回，若因此导致积分或优惠券过期等问题，建议与客服人员进行沟通协商。
			</div>
			<div>
				(9) 积分商城平台所提供的各项礼品/服务，系积分商城平台的供应商提供，芬尼与供应商间并无合伙、经销、代理关系或共同出售人、广告媒体或保证人关系；用户所兑换礼品/服务由各供应商提供，其质量、数量、款式、颜色、售后服务等问题均由供应商负责。如用户对供应商提供的礼品/服务及售后服务有争议时，芬尼负责协助用户与供应商取得联系，具体联系方式参见礼品/服务介绍详情页。
			</div>
			<div>
				(10) 如审查发现用户存在不正当手段获取积分等非正常使用行为和破坏积分商城的公平性和其他用户的权益等异常情况，芬尼有权冻结用户积分并拒绝执行兑换请求，同时保留追究因用户滥用积分而产生的损失的权利。（如出现同一用户绑定同一类目的机器超过5台，则会判定为异常情况，后台有可能冻结此用户积分等权益）
			</div>

			<div class=" marginTop8">六、责任与义务</div>
			<div>
				(1) 用户应遵守中国的法律法规，不得利用积分商城进行任何非法活动。如果发现任何非法使用或侵犯他人权益的行为，用户应立即通知我们。
			</div>
			<div>
				(2) 用户的账户和密码是其个人信息的核心组成部分，用户应妥善保管这些信息，同时如果用户发现任何可疑活动或异常情况，应立即通知我们。
			</div>
			<div>
				(3) 用户应了解并同意，我们有权审查和拒绝执行任何被认为是不合法或违反本规则的交易。如果用户对此有任何疑问或不满，应立即联系我们。
			</div>
			<div>
				(4) 我们保留随时修改本规则的权利，修改后的规则将通知用户。同时，如果修改后的规则对用户的权益有实质性的影响，我们将通过APP推送通知用户。如果用户继续使用我们的服务，则视为接受修改后的规则。如果用户不接受修改后的规则，应立即停止使用我们的服务。
			</div>
			<div>
				(5) 本规则的解释权归我们所有。如果用户发现任何违规行为或对积分商城的使用有任何疑问，可以随时联系我们，我们将尽快回复并提供帮助。我们的联系方式如下：APP内客服。我们将尽最大努力保证积分商城的正常运营和用户数据的安全性。但是，由于一些不可抗力因素（如自然灾害、网络故障等），我们可能无法提供正常的服务。在这种情况下，我们不承担任何责任并保留采取必要措施以保护用户数据和服务的权利。
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'PointsMallRules'
	}
</script>

<style scoped>
	/* 页面整体样式 */
	.points-mall-rules-page {
		padding: 16px;
		background-color: #fff;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
		color: #333;
		line-height: 1.6;
		margin-bottom: 80px;
	}

	/* 标题区域 */
	.title-section {
		margin-bottom: 20px;
	}

	.main-title {
		font-size: 24px;
		font-weight: bold;
		margin-bottom: 8px;
	}

	.sub-desc {
		font-size: 14px;
		color: #666;
	}

	/* 规则内容通用样式 */
	.rules-content {
		font-size: 12px;
		color: #9696A0;
	}

	.chapter-title {
		font-size: 16px;
		font-weight: bold;
		margin: 20px 0 8px;
	}

	.chapter-paragraph {
		margin-bottom: 8px;
	}

	/* 列表样式 */
	.chapter-list {
		margin-bottom: 8px;
		list-style: disc;
	}

	.chapter-ordered-list {
		margin-bottom: 8px;
		list-style: decimal;
	}

	.chapter-list li,
	.chapter-ordered-list li {
		margin-bottom: 4px;

	}
	
	.marginTop8 {
		margin-top: 8px;
	}
</style>